up.$macro('a[aria-label], button[aria-label]', ($element) => {
  $element.attr({ 'title': $element.attr('aria-label') })
})
